import { ResponseManipulatorType } from '../../cache-logic-interface';

export let customMutationManipulator: ResponseManipulatorType = {
  default: (cache, cacheKey, request) => {
    return cache.getCacheData(cacheKey);
  },
};
